import * as Yup from "yup";
import { getJurisdictionalLabelGetters, type SupportedCountry } from "shared-ui/kyc";

const US_FIVE_DIGIT_ZIP_REGEX = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

export const addressModalSchema = Yup.object().shape({
  country_code: Yup.string().required("Country is required"),
  address_line_1: Yup.string().required("Address line 1 is required"),
  address_line_2: Yup.string().nullable(),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  zip_code: Yup.string()
    .test("zip-code-required", "", function (value) {
      if (!value) {
        const { country_code } = this.parent;
        const { getPostCodeLabel } = getJurisdictionalLabelGetters();
        const label = getPostCodeLabel(country_code as SupportedCountry);
        return this.createError({ message: `${label} is required` });
      }
      return true;
    })
    .test("zip-code-format", "Please enter a valid 5-digit ZIP code", function (value) {
      const { country_code } = this.parent;
      if (country_code === "US") {
        if (!value) {
          return false;
        }
        return US_FIVE_DIGIT_ZIP_REGEX.test(value);
      }
      return true;
    }),
});
